import {Button, Grid} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../../../../../../../store/index"
import {simsToIccIdAndMsisdnList} from "../../../../../../../../../../shared/utils/utils";

const ActivationRequestStepActions = ({
                                          step,
                                          setStep,
                                          onConfermaClick,
                                          handleDialogClose,
                                          handleStepBack,
                                          isButtonDisabled,
                                          selectedValues,
                                          selectedSims
                                      }) => {
    const dispatch = useDispatch()
    const planOptions = useSelector(state => state.ordiniConsipReducer.consipPlans.data)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const userClaims = useSelector((state) => state.authReducer.userClaims)


    const handleOnConfermaClick = () => {
        const planToDisplay = planOptions.filter(i => i.id === selectedValues.planType);
        const simIccIdList = simsToIccIdAndMsisdnList(selectedSims);

        dispatch(actions.submitReportInSegnalazione(
            selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId,
            "TM9_CONSIP_PRIMARIA",
            userClaims.uid,
            "",
            "",
            "",
            "",
            "",
            simIccIdList,
            `${selectedValues.serviceType} - ${planToDisplay[0].shortNomePiano}`,
            [],
            [],
            () => setStep(2),
        ));
    }
    return (
        <Grid container justifyContent={"space-between"}>
            {step === 0 ?
                <Button onClick={() => handleDialogClose()}
                        color="primary"
                        variant="outlined">
                    Annulla
                </Button> :
                <Button onClick={() => handleStepBack()}
                        color="primary"
                        variant="outlined">
                    Indietro
                </Button>
            }
            <Button color="primary"
                    variant="contained"
                    disabled={isButtonDisabled}
                    onClick={step === 0 ? () => onConfermaClick() : () => handleOnConfermaClick()}>
                Conferma
            </Button>
        </Grid>
    )
}

export default ActivationRequestStepActions;
